import React, { useState } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import FallbackTypography from '../shared/FallbackTypography';

const CopyableText = ({ value }) => {
    const [hovered, setHovered] = useState(false);
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(value);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <Box
            sx={{ display: 'inline-flex', alignItems: 'center' }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => {
                setHovered(false);
                setCopied(false);
            }}>
            <FallbackTypography
                variant="body1"
                fontWeight="bold"
                component="span"
                value={value}
            />
            <Box
                sx={{
                    width: 24,
                    height: 24,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    ml: 1,
                }}>
                {hovered && (
                    <Tooltip title={copied ? 'Copied!' : 'Copy'}>
                        <IconButton
                            onClick={handleCopy}
                            size="small"
                            sx={{ padding: 0 }}
                        >
                            <ContentCopyIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                )}
            </Box>
        </Box>
    );
};

export default CopyableText;